class RecoverPassword {
	constructor() {
		this.loginSection = document.querySelector(".account_form.login")
		this.recoverSection = document.querySelector(".account_form.recover")
		this.emailedSection = document.querySelector(".account_emailed")

		const location = this.getLocation(window.location.href)
		this.showAccordingSection(location)

		window.addEventListener("popstate", () => {
			const location = this.getLocation(window.location.href)
			this.showAccordingSection(location)
		})
	}

	showAccordingSection(location) {
		switch (location) {
			case "recover":
				this.loginSection.style.display = "none"
				this.emailedSection.style.display = "none"
				this.recoverSection.style.display = "block"
				break
			case "emailed":
				this.loginSection.style.display = "none"
				this.recoverSection.style.display = "none"
				this.emailedSection.style.display = "block"
				break
			default:
				this.recoverSection.style.display = "none"
				this.emailedSection.style.display = "none"
				this.loginSection.style.display = "block"
				break
		}
	}

	getLocation(href) {
		return href.split("#")[1]
	}
}

new RecoverPassword()
